import React from 'react';
import cn from 'classnames';
import { i18n } from 'utils/i18n';
import { getFormattedPrice } from 'utils/prices';
import { getImageFromImagesObject } from 'utils/vehicles';
import Button from 'components/Button';
import Picture from 'components/Picture';
import BundlePrice from './BundlePrice';
import { propTypes } from './bundlesCardPropTypes';

const BundlesCard = (props) => {
  const {
    name,
    title,
    isSelected,
    image_icon,
    includedBundlesExtras,
    upgrade_bundle_view,
    bundle_value_view,
    savings_view,
    vehicle_rates,
    onClickBundle,
    showBundlesDetailsModal,
    description,
    additionalDriversPolicy,
  } = props;

  const handleClickCard = (evt) => {
    evt.preventDefault();
    onClickBundle(name, isSelected);
  };

  const handleViewDetails = (extras, bundledAdditionalDrivers) => (evt) => {
    if (evt && typeof evt.preventDefault === 'function') {
      evt.preventDefault();
    }
    showBundlesDetailsModal(title, description, extras, bundledAdditionalDrivers, additionalDriversPolicy);
  };

  const renderExtra = (item) => (
    <li key={item.code} className='bundles-card__extras__item'>
      {item.name}
      {item.selected_quantity && item.max_quantity > 1 ? ` (x${item.selected_quantity})` : null}
    </li>
  );

  const upgradeBundle = getFormattedPrice(upgrade_bundle_view);
  const savings = getFormattedPrice(savings_view);
  const value = getFormattedPrice(bundle_value_view);
  // AWR-4167 - Savings tag was temporarily disabled
  // const shouldRenderSavingTag = !!savings_view;
  const shouldRenderSavingTag = false;
  const bundledAdditionalDrivers =
    vehicle_rates?.supplemental?.additional_driver?.number_of_free_additional_drivers || null;

  const bundleImage = getImageFromImagesObject({ image_icon }, { type: 'image_icon' });
  const extras = includedBundlesExtras[name];

  return (
    !!title &&
    !!extras.length && (
      <div
        className={cn('bundles-card__container', {
          'bundles-card__container--selected': isSelected,
          'bundles-card__container--no-savings': !shouldRenderSavingTag,
        })}
      >
        {shouldRenderSavingTag && (
          <div className='bundles-card__banner bundles-card__banner--tag'>
            <span>
              <BundlePrice priceAmount={savings} title='bundles_card_save_amount' />
              &nbsp;
            </span>
            <span>
              <BundlePrice priceAmount={value} title='bundles_card_value_amount' />
            </span>
          </div>
        )}
        <div className='bundles-card__title'>
          {!!bundleImage && (
            <Picture
              className='bundles-card__badge'
              src={bundleImage}
              alt={title}
              srcMobile={bundleImage}
              srcTablet={bundleImage}
            />
          )}
          <h3>{title}</h3>
          <Button
            onClick={handleViewDetails(extras, bundledAdditionalDrivers)}
            ariaText={`${name} ${i18n('bundles_card_details_cta')}`}
            data-dtm-track={`extras_bundle|${title}:add`}
            linkText
          >
            {i18n('bundles_card_details_cta')}
          </Button>
        </div>
        <div className='bundles-card__extras'>
          <ul>
            {extras && extras.map((item) => renderExtra(item))}
            {bundledAdditionalDrivers && (
              <li className='bundles-card__extras__item'>
                {i18n('bundles_card_additional_drivers', [bundledAdditionalDrivers])}
              </li>
            )}
          </ul>
        </div>
        {isSelected ? (
          <Button
            className='bundles-card__price bundles-card__price--selected'
            data-dtm-track={`extras_bundle|${title}:remove`}
            link
            ariaText={`${i18n('bundles_card_remove_cta')} ${title}`}
          >
            <BundlePrice priceAmount={upgradeBundle} title='bundles_card_was_added_cta' />
            <span onClick={handleClickCard} className='bundles_card__remove_cta'>
              {i18n('bundles_card_remove_cta')}
            </span>
          </Button>
        ) : (
          <Button
            className='bundles-card__price formatted-price'
            onClick={handleClickCard}
            link
            data-dtm-track={`extras_bundle|${title}:add`}
            ariaText={i18n('bundles_card_add_cta', [upgradeBundle])}
          >
            <BundlePrice priceAmount={upgradeBundle} title='bundles_card_add_cta' />
          </Button>
        )}
      </div>
    )
  );
};

BundlesCard.propTypes = propTypes;

export default BundlesCard;
